import { useCallback, useEffect, useRef, useState } from "react";
import { copiedNote } from "./parts";

/** The note that drops in after an action on a phone or an iPad (the app's Toast), and what copying says. */
export function useSay() {
  const [toast, setToast] = useState({ msg: "", on: false, done: true });
  const timer = useRef<number | null>(null);
  useEffect(() => () => void (timer.current && window.clearTimeout(timer.current)), []);

  const say = useCallback((msg: string, done = true) => {
    setToast({ msg, on: true, done });
    if (timer.current) window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setToast((t) => ({ ...t, on: false })), 2600);
  }, []);

  const copied = useCallback(
    (label: string, ok: boolean) => say(copiedNote(label, ok), ok),
    [say],
  );

  return { toast, say, copied };
}
